export const authTokenKey = 'authToken';

let loginInProgress = false;

export function setLoginInProgress(value: boolean) {
  loginInProgress = value;
}

export function isLoginInProgress() {
  return loginInProgress;
}

export function getAuthToken() {
  const token = localStorage.getItem(authTokenKey);
  return token ? JSON.parse(token) : null;
}

export const login = () => {
  const encodedUrl = encodeURIComponent(window.location.href);
  window.location.href = `https://portal.ipsos.cz/crossroads?returnUrl=${encodedUrl}`;
};

export const logout = () => {
  localStorage.removeItem(authTokenKey);
  login();
};
